// Typed wrappers for JSSDK

import {
  CloseAppOptions,
  OpenWebViewParams,
  CloseAppParams,
  GetPlatformInformationRes,
  GetPlatfromInfoParams,
} from '@/types'

declare const pp: {
  closeApp: (params?: CloseAppParams) => void
  openWebview: (params: OpenWebViewParams) => void
  getPlatformInformation: (params: GetPlatfromInfoParams) => void
}

export const closeApp = (options?: CloseAppOptions) => {
  if (options) {
    pp.closeApp({ options })
  } else {
    pp.closeApp()
  }
}

export const openWebview = (params: OpenWebViewParams) => {
  pp.openWebview(params)
}

export const getPlatformInformation = (): Promise<GetPlatformInformationRes | null> => {
  return new Promise((resolve) => {
    pp.getPlatformInformation({
      success: (result) => {
        resolve(result)
      },
      fail: (result) => {
        console.log('getPlatformInformation fail', result.errorCode)
        resolve(null)
      },
    })
  })
}
